var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Convert", centered: "" },
      on: { hide: _vm.closeHandler, show: _vm.reset },
      scopedSlots: _vm._u(
        [
          _vm.options.length
            ? {
                key: "modal-footer",
                fn: function () {
                  return [
                    _c(
                      "ButtonPrimary",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.option || _vm.isLoading,
                        },
                        on: { click: _vm.accept },
                      },
                      [_vm._v("\n      Yes\n    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "ButtonOutline",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal.hide()
                          },
                        },
                      },
                      [_vm._v("\n      No\n    ")]
                    ),
                  ]
                },
                proxy: true,
              }
            : {
                key: "modal-footer",
                fn: function () {
                  return [
                    _c(
                      "ButtonOutline",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal.hide()
                          },
                        },
                      },
                      [_vm._v("\n      Cancel\n    ")]
                    ),
                  ]
                },
                proxy: true,
              },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _vm.options.length
                ? _c(
                    "b-form-group",
                    _vm._l(_vm.options, function (opt) {
                      return _c(
                        "b-form-radio",
                        {
                          key: opt,
                          attrs: { value: opt },
                          model: {
                            value: _vm.option,
                            callback: function ($$v) {
                              _vm.option = $$v
                            },
                            expression: "option",
                          },
                        },
                        [_vm._v("\n        " + _vm._s(opt) + "\n      ")]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.options.length
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Conversion Options" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.conversionOptions },
                        model: {
                          value: _vm.conversionOption,
                          callback: function ($$v) {
                            _vm.conversionOption = $$v
                          },
                          expression: "conversionOption",
                        },
                      }),
                    ],
                    1
                  )
                : _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(
                      "\n      Cannot convert the selections which are not similar file type\n    "
                    ),
                  ]),
            ],
            1
          )
        : _c("b-spinner"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }